import React, {Fragment} from "react";
import {
    Button,
    Col,
    Collapse,
    Descriptions,
    Divider,
    Dropdown,
    List,
    Menu, notification,
    Popconfirm,
    Row,
    Space,
    Tag,
    Tooltip, Typography
} from "antd";
import PermissionHidden from "../../../../components/permissions/PermissionHidden";
import {
    AlertOutlined,
    CommentOutlined,
    CreditCardOutlined,
    DeleteOutlined, EditOutlined,
    EnvironmentOutlined, FieldTimeOutlined, FileOutlined,
    HomeOutlined,
    HourglassOutlined,
    InfoCircleOutlined,
    LinkOutlined,
    MailOutlined,
    MergeCellsOutlined, MinusCircleOutlined,
    NodeIndexOutlined,
    PhoneOutlined,
    PlusOutlined, ReloadOutlined,
    RollbackOutlined, ScheduleOutlined,
    SkinOutlined,
    TagOutlined, VerticalAlignBottomOutlined
} from "@ant-design/icons";
import RestrictedHidden from "../../../../components/permissions/RestrictedHidden";
import {checkForfait, checkPermissions} from "../../../../components/permissions/functions";
import {APP_PREFIX_PATH, ASSET_BASE_URL} from "../../../../configs/AppConfig";
import ContactIcon from "../../../../components/util-components/ContactIcon";
import moment from "moment";
import IntlMessage from "../../../../components/util-components/IntlMessage";
import ApiService from "../../../../services/ApiService";

const {Text, Title} = Typography

export class FicheEnfants extends React.Component {


    async onDeleteChild(id) {
        if (!checkPermissions(["contact.edit"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        const selected = this.props.selected

        await ApiService.post("/contact/child/unlink/" + selected.id + "/" + id)
        await this.props.fiche.getData()

        notification.success({
            message: <IntlMessage id="success.delete"/>
        })
    }


    render() {
        const {selected, fiche} = this.props

        if (!selected) {
            return null
        }

        if (selected.enfants.length === 0) {
            return null
        }

        return (
            <Col style={{padding: 20}}>
                {selected.enfants.map((item, index) => {
                    return (
                        <Fragment key={index}>
                            <Space size="large">
                                <Popconfirm
                                    title="Êtes-vous sûrs de vouloir retirer cet enfant du contact ?"
                                    onConfirm={() => this.onDeleteChild(item.id)}
                                    okText="Oui"
                                    cancelText="Non"
                                    okType={"danger"}
                                >
                                    <Button danger type={"text"} icon={<MinusCircleOutlined/>}/>
                                </Popconfirm>

                                <Button icon={<ContactIcon contact={item}/>}
                                        type="link"
                                        onClick={() => fiche.modalContact.show(item.id)}>{item.nom} {item.prenom}</Button>
                            </Space>
                            {selected.enfants.length > 1 && index < selected.enfants.length - 1 && (
                                <Divider/>
                            )}
                        </Fragment>

                    )
                })
                }
            </Col>
        )
    }
}
